import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const customerImporterSelectors = importerSelectors(
  'customer.importer',
)

export default customerImporterSelectors
